import { IconManager } from '@speeki/icons';

import nicoleAvatar from '@assets/images/nicole.png';

import { useTenantAvatar } from '@utils/hooks/useTenantAvatar';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';
import {
    AvatarAssistantWrapper,
    CustomAvatarImage,
    NicoleImageWrapper,
    SpeekiLogoIcon,
} from '@domains/new-conversation/atoms/AvatarAssistant/AvatarAssistant.styled';

interface AvatarAssistantProps {
    isMd: boolean;
}
export const AvatarAssistant = ({ isMd }: AvatarAssistantProps) => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;

    const { data: companyInformationData } = useTenantAvatar({
        fetchPolicy: 'cache-only',
        skip: !isLoggedIn,
    });

    const nicoleSetting =
        companyInformationData?.tenant.assetSettings.nicoleSetting;

    if (nicoleSetting === 'CUSTOM')
        return (
            <AvatarAssistantWrapper>
                <CustomAvatarImage
                    alt="CustomAvatar"
                    src={
                        companyInformationData?.tenant.assetSettings
                            .nicoleAvatarUrl ?? ''
                    }
                />
            </AvatarAssistantWrapper>
        );
    if (nicoleSetting === 'DISABLED') {
        return (
            <AvatarAssistantWrapper>
                <SpeekiLogoIcon>
                    <IconManager
                        icon={'SvgSpeekiLogo'}
                        size={isMd ? 16 : 70}
                        themeColors={{
                            default: { 'color-5': 'main.secondary' },
                        }}
                    />
                </SpeekiLogoIcon>
            </AvatarAssistantWrapper>
        );
    }
    if (nicoleSetting === 'DEFAULT')
        return (
            <NicoleImageWrapper>
                <img alt="Nicole" src={nicoleAvatar as string} />
            </NicoleImageWrapper>
        );
    return <></>;
};
